import { Column, RawColumn, Section } from '../models';

/**
 * Returns an array of Column merging all section columns
 * @param sections
 */
export const mergeSectionColumnsAsList = <T extends RawColumn = Column>(sections: Array<Partial<Section<T>>>): T[] =>
  sections.reduce((acc, s) => [...acc, ...s.columns], []);

/**
 * Returns all columns passed as a map of columns based on columnId
 * @param columns {Column[]}
 */
export const makeColumnsMap = <T extends RawColumn = Column>(columns: T[]): { [key: number]: T } =>
  columns.reduce((acc, c) => ({ ...acc, [c.columnId]: c }), {});

/**
 * Returns all columns on each passed section as a map of columns based on columnId
 * @param sections {Section[]}
 */
export const mergeSectionColumnsAsMap = <T extends RawColumn = Column>(sections: Array<Partial<Section<T>>>) =>
  makeColumnsMap(mergeSectionColumnsAsList(sections));
